import { render, staticRenderFns } from "./OrgCompare.vue?vue&type=template&id=50e5d1e7"
import script from "./OrgCompare.vue?vue&type=script&lang=js"
export * from "./OrgCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports